// src/routes/ProtectedRoute.jsx
import { useGetUser } from "@/api/users";
import { getStoredUserId, getUserPermissions, isAuthTokenValid } from "@/utils";
import { Navigate } from "react-router";

export default function ProtectedRoute({ children, featureKey }) {
  // Token-based gate
  if (!isAuthTokenValid()) return <Navigate to="/auth/login" replace />;

  const userId = getStoredUserId();
  if (!userId) return <Navigate to="/auth/login" replace />;

  const { data, isLoading } = useGetUser(userId);
  if (isLoading) return null;

  const perms = getUserPermissions(data);
  if (featureKey && perms && perms[featureKey] !== true) {
    return <Navigate to="/permission-denied" replace />;
  }

  return children;
}
